angular.module('pipSettings.Service', []);

import './SettingsConfig';
import './SettingsPageSelectedTab';
import './SettingsStateConfig';
import './SettingsTab';
import './SettingsService';

export * from './SettingsConfig';
export * from './SettingsPageSelectedTab';
export * from './SettingsStateConfig';
export * from './SettingsTab';
export * from './SettingsService';
